import {
  FETCH_RESOURCES_REQUEST,
  FETCH_RESOURCES_SUCCESS,
  FETCH_RESOURCES_FAILURE,
} from "./types";

import { getAllResources as getAllResourcesApi } from "../../services/resourceService";

// Action Creators
export const fetchResourcesRequest = () => ({
  type: FETCH_RESOURCES_REQUEST,
});

export const fetchResourcesSuccess = (data) => ({
  type: FETCH_RESOURCES_SUCCESS,
  payload: data,
});

export const fetchResourcesFailure = (error) => ({
  type: FETCH_RESOURCES_FAILURE,
  payload: error,
});

// Thunk
export const fetchResources = () => async (dispatch) => {
  dispatch(fetchResourcesRequest());

  try {
    const response = await getAllResourcesApi();


    if (response.success) {
      dispatch(fetchResourcesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      dispatch(
        fetchResourcesFailure(response.error || "Failed to fetch resources")
      );
      return {
        success: false,
        error: response.error || "Failed to fetch resources",
      };
    }
  } catch (error) {
    dispatch(
      fetchResourcesFailure(error.message || "Something went wrong")
    );
    return {
      success: false,
      error: error.message || "Something went wrong",
    };
  }
};